<template>
    <div :class="['hpHero', 'reveal active']" style="width:100%;">
      
      <div class="heroVideoWrapper">
        <video playsinline autoplay muted loop id="videoBgHero" 
          :class="['heroVideoConatiner',showVideo ? 'active' : '']">
          <source :src="getVideoUrl()" type="video/mp4">
        </video>
      </div>

<!--       <div class="heroContent">
          <div class="heroText">
              <div class="hero-title sptx">
                  <splitter :content="localize(sectionData.title)" startDelay='0.1' startOnLoad="true">
                  </splitter>
              </div>  
              <div class="hero-desc sptx pt-l">
                <splitter :content="localize(sectionData.desc)" startDelay="0.4" startOnLoad="true">
                </splitter>
              </div>

              <div :class="['heroBtnWrapper', showBtn ? 'showBtn' : '']">
                  <a class="roundBtn" @click="scrollToNextSection" >
                      <span class="title">{{localize('@explore')}}</span>
                      <i class="fal fa-chevron-down pl-s" ></i>
                  </a>
              </div>

          </div>
      </div>
 -->    </div>
</template>

<style>
    .heroVideoWrapper
    {
      width: 100vw;
      max-height: 100vh;
      height: 100vh;
      overflow: hidden;
    }
    .heroVideoWrapper video
    {
      overflow: hidden;
      position: relative;
      z-index: 1;
      left: 50%;
      top:50%;
      /*       min-width: 100%;
              min-height: 100%;
      */      
      transform: translate(-50%,-50%);
      height: auto;
      width: 100vw;
    }

  @media (hover:hover) {
  }


    @media (max-width: 850px) { 

      .heroVideoWrapper
      {
        width: 100vw;
        height: 100vh;
        max-height: 100vh;
        overflow: hidden;
        position: relative;
        padding-top: 0px;
        margin-top: 0px;    
        margin-bottom: 0px;    
        padding-bottom: 0px;
        overflow: hidden;
      }  
      .heroVideoWrapper video {
        height: 100vh;
        max-height: 100vh;
        width: auto;
      }

    }

    @media (max-width: 400px) { 

    }

    /* Portrait iPad mini 1, iPad 1 and iPad 2*/
    @media only screen 
    and (min-device-width: 768px) 
    and (max-device-width: 1024px) 
    and (-webkit-min-device-pixel-ratio: 1) 
    and (orientation: portrait)
    {

    }    
</style>


<script>
import { mapActions, mapState } from "vuex";
import { splitLines,isMobileScreen }         from "@/utils";
import splitter from "@/views/com/splitter.vue";

export default 
{
  name: "hpHero",
  components:{splitter},
  data(){
      return {
          isMobileLayout:false,
          showVideo:false,
          showBtn:false
      }
  },
  mounted() 
  {
    var vm = this;    
    vm.startAnimation();
    vm.isMobileLayout = isMobileScreen();

    //alert("vm.isMobileLayout="+vm.isMobileLayout);

    //setTimeout(() => {
      //vm.showBtn=true;//start the video after 2 sec
    //}, 200);

    setTimeout(() => {
      vm.showVideo=true;//start the video after 2 sec
    }, 2000);
  },
  methods: {
    scrollToNextSection()
    {
        document.getElementsByClassName("siteSection")[1].scrollIntoView({ 
          behavior: 'smooth' 
        });

    },
    getVideoUrl()
    {
        if(isMobileScreen()){
          return "img/video/MIS_Lance_plus_con_hero_mobile.mp4"
        }else{
          return "img/video/MIS_LANCE_plus_Con_hero.mp4";
        }
    },
    startAnimation()
    {
        var vm = this;
    }
  },
  computed: {
    ...mapState(["siteData"]),
      sectionData(){
          return this.siteData.SECTIONS[0];
      }
    //...mapState(["pageLayoutData", "locale", "dirtyHome"]),
  }
};
</script>

